import $ from 'cash-dom';

$(function () {
	const TestLocation = {
		_location: $('#test-location').val(),
		_scrollTriggerSelectors: {
			'reached_vendor_2': '.ppc-vendor-2:not(.hidden)',
			'reached_vendor_3': '.ppc-vendor-3:not(.hidden)',
			'reached_vendor_4': '.ppc-vendor-4:not(.hidden)',
			'reached_vendor_5': '.ppc-vendor-5:not(.hidden)',
			'reached_vendor_6': '.ppc-vendor-6:not(.hidden)',
			'reached_vendor_7': '.ppc-vendor-7:not(.hidden)',
			'reached_vendor_8': '.ppc-vendor-8:not(.hidden)',
			'reached_vendor_9': '.ppc-vendor-9:not(.hidden)',
			'reached_vendor_10': '.ppc-vendor-10:not(.hidden)',
			'quiz': '.quiz',
			'top_ranked_choice': '.editor-choice',
			'cross_chart_1': '.cross-chart.position-1',
			'cross_chart_2': '.cross-chart.position-2',
			'document_below_the_charts': '.ppc-article',
			'faq': '',
			'footer': 'footer',
            'ai_summary_hover': '.ai-summary-btn.desktop',
            'ai_summary_click': '.ai-summary-btn.mobile'
		},
		_elementToTriggerEvent: null,
        _eventSent: false,

		initAndRun() {
			this._init();
			this._run();
		},

		_init() {
			if (!this._location) {
				return;
			}

			const selector = this._scrollTriggerSelectors[this._location];
			let $element = $(selector);

			if (this._location === 'faq') {
				$element = this._findFaq();
			}

			if ($element && $element.length) {
                if (this._location === 'ai_summary_hover' || this._location === 'ai_summary_click') {
                    this._elementToTriggerEvent = $element;
                } else {
                    this._elementToTriggerEvent = $element.get(0);
                }
			}
		},

		_findFaq() {
			let $faq = null;

			$('article h2').each((i, el) => {
				const $el = $(el);
				const text = $el.text().trim();

				if (text.toUpperCase() === 'FAQ' || text.toLowerCase() === 'frequently asked questions') {
					$faq = $el;
					return;
				}
			});

			return $faq;
		},

		_run() {
			if (!this._location) {
				return;
			}

			if (this._location === 'exit-pop') {
				this._runForExitPopup();
			} else if (this._location === 'prequal') {
				this._runForPrequal();
			} else if (this._location === 'ai_summary_hover' || this._location === 'ai_summary_click') {
                this._runForAISummary();
            } else {
				this._runForElements();
			}
		},

		_runForExitPopup() {
			$(document).on('exit-popup-shown', () => {
				this._sendAloomaEvent();
			});
		},

		_runForPrequal() {
			$(document).on('PrequalifyModalHandler:prequalShown', () => {
				this._sendAloomaEvent();
			});
		},

        _runForAISummary() {
            if (!this._elementToTriggerEvent) {
                return;
            }

            const event = this._location === 'ai_summary_click' ? 'click' : 'mouseover';
            this._elementToTriggerEvent.on(event, () => {
                if (!this._eventSent) {
                    this._eventSent = true;
                    this._sendAloomaEvent();
                }
            })
        },

		_runForElements() {
			if (!this._elementToTriggerEvent) {
				return;
			}

			if (this._isElementInVisibleArea(this._elementToTriggerEvent)) {
				this._sendAloomaEvent();

				return;
			}

			const $window = $(window);

			const scrollHandler = () => {
				if (this._isElementInVisibleArea(this._elementToTriggerEvent)) {
					this._sendAloomaEvent();
					$window.off('scroll', scrollHandler);
				}
			};

			$window.on('scroll', scrollHandler);
		},

		/**
		 * @param {Element|null} element
		 * @return {boolean}
		 * @private
		 */
		_isElementInVisibleArea(element) {
			if (!element) {
				return false;
			}

			return element.getBoundingClientRect().bottom >= 0
				&& element.getBoundingClientRect().top <= window.innerHeight;
		},

		_sendAloomaEvent() {
			Alooma.aloomaSendExperimentEvent('experiment_seen');
		}
	};

	TestLocation.initAndRun();
});
